// noinspection GraphQLUnresolvedReference

import { impresoraFragmentAst } from '../../base/Impresora/fragments/impresoraFragment.ts'
import { puntoVentaFragmentAst } from '../../../base/fragments/puntoVentaFragment.ts'
import { sucursalFragmentAst } from '../../../base/fragments/sucursalFragment.ts'
import { gqlAst } from '../../../utils/gql.ts'

export const ComandaLineaEstadoFragmentAst = /* GraphQL */ gqlAst`
	fragment comandaLineaEstadoFields on RestComandaLineaEstado {
		cantidad
		modificadores {
			cantidad
			nombre
			opcion
			unidadMedida
		}
		notas
		unidadMedida
		variaciones {
			cantidad
			nombre
			tipo
			unidadMedida
		}
	}
`

export const ComandaLineaFragmentAst = /* GraphQL */ gqlAst`
	${ComandaLineaEstadoFragmentAst}
	fragment comandaLineasFields on RestComandaLinea {
		actual {
			...comandaLineaEstadoFields
		}
		anterior {
			...comandaLineaEstadoFields
		}
		areasImpresion
		codigoArticulo
		nombreArticulo
		nroItem
		numeroComandaAnterior
		tipoCambio
	}
`

/**
 * Estado aceptado PENDIENTE | EN_PREPARACION | LISTO | ENTREGADO | ANULADA; null en modo IMPRESION
 * modo: IMPRESION | PANTALLA | AMBOS
 */
export const ComandaAreaFragmentAst = /* GraphQL */ gqlAst`
  ${impresoraFragmentAst}
  fragment comandaAreasFields on RestComandaArea {
    area
    estado
    impresa
    impresiones {
      contingencia
      equipo
      fecha
      ok
      usuario
    }
    impresoras {
      ...impresoraFields
    }
    modo
    nombre
    registrada
    transiciones {
      estado
      fecha
      usuario
    }
  }
`

/**
 * Área de producción (estación).
 * Los artículos se enrutan a áreas y cada área recibe sus comandas por pantalla de cocina, impresoras o ambas.
 * tipo = NUEVA | MODIFICACION | CANCELACION
 * tipoPedido = DELIVERY | LLEVAR | null
 */
export const ComandaFragmentAst = /* GraphQL */ gqlAst`
	${ComandaAreaFragmentAst}
	${ComandaLineaFragmentAst}
	${sucursalFragmentAst}
	${puntoVentaFragmentAst}

	fragment comandasFields on RestComanda {
		_id
		areas {
			...comandaAreasFields
		}
		createdAt
		espacio {
			_id
			descripcion
		}
		lineas {
			...comandaLineasFields
		}
		mesa {
			nombre
		}
		nota
		numeroComanda
		numeroOrden
		numeroPedido
		pedidoId
		puntoVenta {
			...puntoVentaFields
		}
		sucursal {
			...sucursalFields
		}
		tipo
		tipoPedido
		updatedAt
		usucre
	}
`
/**
 * Área de producción (estación).
 * Los artículos se enrutan a áreas y cada área recibe sus comandas por pantalla de cocina, impresoras o ambas.
 * tipo = NUEVA | MODIFICACION | CANCELACION
 * tipoPedido = DELIVERY | LLEVAR | null
 */
export const CocinaComandaFragmentAst = /* GraphQL */ gqlAst`
  ${ComandaFragmentAst}
  fragment cocinaComandaFields on RestCocinaComandasResult {
    version
    comandas {
      ...comandasFields
    }
  }
`
